export default class Address {

    public street: string | undefined;
    public city: string | undefined;
    public zipCode: string | undefined;
    public country: string | undefined;

    constructor(data: { [key: string]: any }) {
        this.street = data['street'] || undefined;
        this.city = data['city'] || undefined;
        this.zipCode = data['zipCode'] || undefined;
        this.country = data['country'] || undefined;
    }
}